import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpContext } from "@angular/common/http";
import { UrlService } from "../../../../environments/urlService";
import { OrganizationDTO } from "../dto/OrganizationDTO";
import { Observable } from "rxjs";
import { IS_SPINNER_ACTIVE } from "../../../util/interceptors";

@Injectable({
  providedIn: 'root',
})
export class OrganizationBackendService {
  private urlService = inject(UrlService);
  private http = inject(HttpClient);
  private readonly url: string;

  constructor() {
    this.url = this.urlService.getModelsUrl() + 'organization';
  }

  create(data: OrganizationDTO): Observable<OrganizationDTO> {
    return this.http.post<OrganizationDTO>(this.url, data, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    });
  }

  update(data: OrganizationDTO): Observable<OrganizationDTO> {
    return this.http.put<OrganizationDTO>(this.url, data, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
      responseType: 'json',
    });
  }

  delete(uuid: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${uuid}`, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }
}
